<template>
    <div class="instagram-post">
        <a target="_blank" :href="'https://instagram.com/p/' + post.shortcode">
            <div class="image-wrapper" style="background-size: cover;" :style="{ 'background-image': 'url(' + (post.imageUrl ? post.imageUrl : '/assets/img/missing_thumbnail.png')  + ')' }">
            </div>
        </a>
        <span class="post-badge" v-if="profileIds.includes(post.profile.userName)">FROM YOU</span>
        <div class="overlay">
            <div class="bottom">
                <div class="d-flex justify-content-center w-100">
		        	<span class="likes mr-2">
						<i class="ei ei-heart_alt"></i>
						{{ post.totalLikes }}
					</span>
                    <span class="comments">
						<i class="ei ei-comment_alt"></i>
						{{ post.totalComments }}
					</span>
                </div>
            </div>
        </div>
        <div class="actions justify-content-center w-100">
            <a :href="respondLink" @click="respond" target="_blank" class="btn btn-default mr-2">Comment</a>
        </div>
    </div>
</template>
<script>
export default {
	props: ['post', 'profileIds'],
	computed: {
		formattedDate() {
			return moment(this.post.publishedDate).format('MMM D YYYY')
		},
		profileName() {
			let name = this.post.profile.userName
			let app = ''

			if (name.length > 18) {
				app += '..'
			}

			name = name.slice(0, 18)

			return name + app
		},
		profileUrl() {
			return 'https://instagram.com/' + this.post.profile.userName
		},
        respondLink() {
            return 'https://instagram.com/p/' + this.post.shortcode
        }
	},
	data() {
		return {
            repost() {
                this.$eventHub.$emit('repostPost', this.post.id)
            },
            respond() {},
            feature() {}
		}
	},
	async mounted() {

	}
}
</script>
